import { useState } from "react";
import { Collapse } from "reactstrap";

const CardCollapse = ({ title, description, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border rounded-sm mb-1 cursor-pointer">
      <div
        className="d-flex align-items-center p-2"
        onClick={() => setOpen((o) => !o)}
      >
        <i
          className={`mdi mdi-chevron-${open ? "down" : "right"}`}
          style={{ fontSize: 24 }}
        />
        <div className="ml-2">
          <h3 className="mb-0">{title}</h3>
          <small>{description}</small>
        </div>
      </div>
      <Collapse isOpen={open}>
        <div className="border-top py-3 px-4 d-flex justify-content-between align-items-center">
          {children}
        </div>
      </Collapse>
    </div>
  );
};

export default CardCollapse;
